export default __webpack_public_path__ + "static/media/Akthe_m_10.37d358e1.png";